// Shared sx for outlined TextField on light backgrounds
export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    '& fieldset': { borderColor: '#dde6f0' },
    '&:hover fieldset': { borderColor: '#5383b3' },
    '&.Mui-focused fieldset': { borderColor: '#0a326d', borderWidth: 2 },
  },
};

// Shared sx for search fields on the app's blue panel backgrounds
export const searchFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 3,
    backgroundColor: '#6a93c4',
    '& fieldset': { border: 'none' },
    '&:focus-within': { boxShadow: '0 0 0 2px rgba(255,255,255,0.35)' },
  },
  '& .MuiInputBase-input': { color: 'white' },
  '& .MuiInputBase-input::placeholder': { color: 'rgba(255,255,255,0.6)', opacity: 1 },
};

// Shared sx for outlined Select fields
export const selectFieldSx = {
  borderRadius: '10px',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dde6f0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#5383b3' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0a326d', borderWidth: 2 },
};

// Shared MenuProps for all Select dropdowns
export const dropdownMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 220,
      mt: 0.5,
      borderRadius: '10px',
      boxShadow: '0 4px 20px rgba(10,50,109,0.12)',
      border: '1px solid #e2e8f0',
      '& .MuiMenuItem-root': {
        fontSize: 13,
        fontWeight: 500,
        color: '#1e3a5f',
        borderRadius: '6px',
        mx: 0.5,
        my: '2px',
        '&:hover': { bgcolor: '#eff6ff' },
        '&.Mui-selected': { bgcolor: '#dbeafe', color: '#0a326d', fontWeight: 600 },
        '&.Mui-selected:hover': { bgcolor: '#bfdbfe' },
      },
      '&::-webkit-scrollbar': { width: '4px' },
      '&::-webkit-scrollbar-track': { background: 'transparent' },
      '&::-webkit-scrollbar-thumb': { background: '#c7d8ec', borderRadius: '4px' },
    },
  },
};
